module.exports = __webpack_public_path__ + "img/avatar.441fcad7.png";